import clsx from 'clsx'
import React from 'react'

const Tab = ({ className, value }: any) => {
    return (
        <span className={clsx("h-fit py-[2px] px-[12px] rounded-[40px] text-small text-center", className)}>
            {value}
        </span>
    )
}

export default Tab
